import { hasModifierKey } from '@angular/cdk/keycodes';
import type { MatDialogRef } from '@angular/material/dialog';
import { filter, takeUntil } from 'rxjs';

import { ESCAPE_KEY } from '../constants/escape-key.constant';

/**
 * Closes a Material dialog on Escape where Material's own handler cannot.
 *
 * Material spends `disableClose` on Escape and the backdrop press together, so a Clarity dialog that
 * refuses the backdrop has to pin that flag on and loses its Escape with it. This hands the Escape
 * back. `canClose` is read on every press, so a body can still lock dismissal while an action runs.
 * `hasModifierKey` and the `preventDefault` are `MatDialogRef`'s own, so the two paths close on
 * exactly the same presses. The subscription ends with the dialog.
 */
export function closeMatDialogOnEscape(dialogRef: MatDialogRef<unknown>, canClose: () => boolean = () => true): void {
	dialogRef
		.keydownEvents()
		.pipe(
			filter(event => event.key === ESCAPE_KEY && !hasModifierKey(event)),
			takeUntil(dialogRef.afterClosed()),
		)
		.subscribe(event => {
			if (!canClose()) {
				return;
			}

			event.preventDefault();
			dialogRef.close();
		});
}
